
import { Link } from "react-router-dom";
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import logo from '../assets/img/arlogo.png';
import jubileeLogo from '../assets/img/Jubilee-Logo.jpeg';
// Custom styles for modern navbar
const navStyles = {
  boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
  borderRadius: '0 0 1.5rem 1.5rem',
  //marginTop: 8,
  padding: 0,
  background: 'rgba(25,135,84,0.98)',
  transition: 'box-shadow 0.3s',
};
const logoCircle = {
  background: 'white',
  borderRadius: '50%',
  width: 48,
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
};

export default function HeaderMain() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [showNav, setShowNav] = useState(false);

  const handleToggle = () => setShowNav(!showNav);
  const handleNavClick = () => setShowNav(false);

  // Custom style for active dropdown item
  const dropdownActiveStyle = {
    backgroundColor: '#198754',
    color: '#fff',
  };
  return (
    <header id="header" className="fixed-top" style={{ background: 'transparent', zIndex: 1030 }}>
      <nav className="navbar navbar-expand-lg navbar-dark py-2" style={navStyles}>
        <div className="container-fluid container-xl  d-flex">
          {/* Left: Logo and Title */}
          <a href="https://archivesj.in" className="navbar-brand d-flex align-items-center gap-2" >
            <span style={logoCircle}>
              <img src={logo} alt="" style={{ height: 32, width: 32, objectFit: 'contain' }} />
            </span>
            <span className="nav-header fw-bold fs-5 d-none d-md-block" style={{ letterSpacing: 0.5 }}>Jesuit Madurai Province Archives (JEMPARC)</span>
            <span className="fw-bold fs-5 d-md-none d-block" style={{ letterSpacing: 0.5 }}>JEMPARC</span>
          </a>
          {/* Right: Nav Items */}
          <button className="navbar-toggler shadow-sm border-0" type="button" aria-controls="mainNavbar" aria-expanded={showNav} aria-label="Toggle navigation" onClick={handleToggle}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse${showNav ? ' show' : ''}`} id="mainNavbar">
            <ul className="navbar-nav mb-2 mb-lg-0 ms-auto">
              {/* ...existing nav items... */}
              <li className="nav-item">
                <Link to="/" className={`nav-link px-3 rounded-pill${currentPath === '/' ? ' active bg-white text-success shadow-sm' : ''}`} onClick={handleNavClick} style={{ transition: 'background 0.2s, color 0.2s' }}>Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className={`nav-link px-3 rounded-pill${currentPath === '/about' ? ' active bg-white text-success shadow-sm' : ''}`} onClick={handleNavClick} style={{ transition: 'background 0.2s, color 0.2s' }}>About Us</Link>
              </li>
              <li className="nav-item">
                <Link to="/application" className={`nav-link px-3 rounded-pill${currentPath === '/application' ? ' active bg-white text-success shadow-sm' : ''}`} onClick={handleNavClick} style={{ transition: 'background 0.2s, color 0.2s' }}>Application</Link>
              </li>
              <li className="nav-item">
                <Link to="/search" className={`nav-link px-3 rounded-pill${currentPath === '/search' ? ' active bg-white text-success shadow-sm' : ''}`} onClick={handleNavClick} style={{ transition: 'background 0.2s, color 0.2s' }}>Catalogue</Link>
              </li>
              {/* Dropdown for Materials 
              <li className="nav-item dropdown">
                <a className={`nav-link dropdown-toggle px-3 rounded-pill${(currentPath === '/research' || currentPath === '/materials') ? ' active bg-white text-success shadow-sm' : ''}`} href="#" id="materialsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Materials
                </a>
                <ul className="dropdown-menu" aria-labelledby="materialsDropdown">
                  <li>
                    <Link
                      to="/research"
                      className={`dropdown-item${currentPath === '/research' ? ' active' : ''}`}
                      style={currentPath === '/research' ? dropdownActiveStyle : {}}
                      onClick={handleNavClick}
                    >
                      Research
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/materials"
                      className={`dropdown-item${currentPath === '/materials' ? ' active' : ''}`}
                      style={currentPath === '/materials' ? dropdownActiveStyle : {}}
                      onClick={handleNavClick}
                    >
                      Documents/Books
                    </Link>
                  </li>
                </ul>
              </li>*/}
              <li className="nav-item">
                <Link to="/gallery" className={`nav-link px-3 rounded-pill${currentPath === '/gallery' ? ' active bg-white text-success shadow-sm' : ''}`} onClick={handleNavClick} style={{ transition: 'background 0.2s, color 0.2s' }}>Gallery</Link>
              </li>
              {/*<li className="nav-item">
                <Link
                  to="/platinum-jubilee"
                  className={`nav-link px-3 rounded-pill fw-semibold d-inline-flex align-items-center gap-1${currentPath.startsWith('/platinum-jubilee') ? ' active bg-warning text-dark shadow-sm' : ' text-warning'}`}
                  onClick={handleNavClick}
                  style={{
                    transition: 'background 0.2s, color 0.2s',
                    border: '1px solid rgba(255, 193, 7, 0.5)',
                    background: currentPath.startsWith('/platinum-jubilee') ? '#ffc107' : 'rgba(0,0,0,0.18)',
                  }}
                >
                  <img
                    src={jubileeLogo}
                    alt="Jubilee"
                    className="rounded-circle"
                    style={{ width: '20px', height: '20px', objectFit: 'cover' }}
                    onError={(e) => {
                      e.target.src = process.env.PUBLIC_URL + '/assets/img/Jubilee-Logo.jpeg';
                    }}
                  />
                  <span>MDU Platinum Jubilee</span>
                </Link>
              </li>*/}
              <li className="nav-item">
                <Link to="/contact" className={`nav-link px-3 rounded-pill${currentPath === '/contact' ? ' active bg-white text-success shadow-sm' : ''}`} onClick={handleNavClick} style={{ transition: 'background 0.2s, color 0.2s' }}>Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
